import { useUserBookReads } from "store/books/booksSelector";
import { BookSerializersBookByline } from "types/serializers";

import EditableDateRead from "./EditableDateRead";

export default function EditableDatesRead({
  book,
}: {
  book: BookSerializersBookByline;
}) {
  const userBookReads = useUserBookReads(book.id);
  if (userBookReads.length === 0) {
    return false;
  }

  return (
    <div>
      {userBookReads.map(dateRead => (
        <EditableDateRead
          userBookRead={dateRead}
          key={`dateRead-${dateRead.id}`}
          book={book}
        />
      ))}
    </div>
  );
}
